import { useState } from "react";
import {
  fetchExhibitorCategories,
  fetchExhibitorCategoryById,
  createExhibitorCategory,
  updateExhibitorCategory,
  deleteExhibitorCategory,
  fetchExhibitorCategoriesTree
} from "../../../api/exhibitorCategory.api";

export const useExhibitorCategory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadCategories = async (companyId) => {
    setLoading(true);
    const res = await fetchExhibitorCategories(companyId);
    setData(res.data?.data || []);
    setLoading(false);
  };

  const loadCategoryById = async (id) => {
    const res = await fetchExhibitorCategoryById(id);
    return res.data?.data;
  };

  const loadCategoryByOrganizer = async (company_id) => {
    setLoading(true);
    const res = await fetchExhibitorCategoriesTree({ company_id });
    setData(res.data?.data || []);
    setLoading(false);
  };

  const addCategory = (payload) => createExhibitorCategory(payload);
  const editCategory = (id, payload) => updateExhibitorCategory(id, payload);
  const removeCategory = (id, payload) => deleteExhibitorCategory(id, payload);

  return {
    data,
    loading,
    loadCategories,
    loadCategoryById,
    addCategory,
    editCategory,
    removeCategory,
    loadCategoryByOrganizer
  };
};
